/**
 * An object containing properties for pagination events
 */
var PaginationEvent = /** @class */ (function () {
    function PaginationEvent() {
    }
    return PaginationEvent;
}());
export { PaginationEvent };
//# sourceMappingURL=pagination-event.js.map